import { render, staticRenderFns } from "./HGOverview.vue?vue&type=template&id=700fcbbc&scoped=true&"
import script from "./HGOverview.vue?vue&type=script&lang=js&"
export * from "./HGOverview.vue?vue&type=script&lang=js&"
import style0 from "./HGOverview.vue?vue&type=style&index=0&id=700fcbbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700fcbbc",
  null
  
)

export default component.exports